"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSecret = exports.isPublic = exports.isPrivate = exports.isPendingGroup = exports.isDefaultGroup = exports.isEmptyGroup = exports.isGroupSecret = exports.isGroupPublic = exports.isGroupPrivate = void 0;
var types_1 = require("../../../types");
function isGroupPrivate(group) {
    return isPrivate(group.settings.privacyLevel);
}
exports.isGroupPrivate = isGroupPrivate;
function isGroupPublic(group) {
    return isPublic(group.settings.privacyLevel);
}
exports.isGroupPublic = isGroupPublic;
function isGroupSecret(group) {
    return isSecret(group.settings.privacyLevel);
}
exports.isGroupSecret = isGroupSecret;
// TODO: why is it privacy?
function isEmptyGroup(group) {
    return !group.groupId;
}
exports.isEmptyGroup = isEmptyGroup;
function isDefaultGroup(group) {
    return group.groupId === 'dummy_group_id';
}
exports.isDefaultGroup = isDefaultGroup;
function isPendingGroup(group) {
    return group.approvalStatus === types_1.ApiTypes.v1.GroupApprovalStatus.PENDING;
}
exports.isPendingGroup = isPendingGroup;
function isPrivate(privacyLevel) {
    return privacyLevel === types_1.ApiTypes.v1.GroupPrivacyLevel.PRIVATE;
}
exports.isPrivate = isPrivate;
function isPublic(privacyLevel) {
    return privacyLevel === types_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC;
}
exports.isPublic = isPublic;
function isSecret(privacyLevel) {
    return privacyLevel === types_1.ApiTypes.v1.GroupPrivacyLevel.SECRET;
}
exports.isSecret = isSecret;
//# sourceMappingURL=index.js.map